import { Label } from "@mui/icons-material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// IAP operational periods are Eastern-time 0700-to-0700 windows.
const OPERATIONAL_TZ = "America/New_York";
const OPERATIONAL_START = "07:00";

// One operational period = 0700 (Eastern) on the chosen date to 0700 (Eastern)
// the next day, returned as UTC ISO instants for the report API. Anchored to
// Eastern so the window is identical no matter where the report is run.
export const toOperationalPeriodWindow = (date: any) => {
  const day = dayjs(date?.toDate ? date.toDate() : date).format("YYYY-MM-DD");
  const start = dayjs.tz(`${day} ${OPERATIONAL_START}`, OPERATIONAL_TZ);
  return {
    startDate: start.toISOString(),
    endDate: start.add(1, "day").toISOString(),
  };
};

// The operational period currently in progress: today's 0700 ET window, or —
// when the clock has not reached 0700 yet — the one that started yesterday.
// Used as the default window for the ICD dashboard card.
export const currentOperationalPeriodWindow = () => {
  const todayWindow = toOperationalPeriodWindow(dayjs());
  if (dayjs().isBefore(dayjs(todayWindow.startDate))) {
    return toOperationalPeriodWindow(dayjs().subtract(1, "day"));
  }
  return todayWindow;
};

// Add your constant here, any text that you use in our application,
export const REPORT_CONSTANTS = {
  CREATE_VISIT: "Create Visit",
  IMPORT_TEMPLATE: "Import Template",
  SUBJECTIVE: "Subjective",
  NO_ORDER_FOUND: "No Order Found",
  CANCEL: "Cancel",
  SAVE_AS_DRAFT: "Save as Draft",
  PROCEED_TO_DISCHARGE: "Proceed to Discharge",
  SAVE: "Save",
  PRINT: "Print",
  FULL_NAME: "Full Name",
  ACTION: "Actions",
  REPORT: "Reports",
  OPEN_HEALTH_HISTORY: "Open Health History",
  CREATE_ORDER: "Create Order",
  ORDER_TYPE: "Order Type",
  MEDICATION_NAME: "Medication Name",
  NOTES: "Notes",
  DATES: "Dates",
  TRANSFER: "Transfer",
  CHIEF_COMPLAINT: "Chief Complaint",
  ENTER_CHIEF_COMPLAINT: "Enter Chief Complaint",
  PROVIDER_TASKS: "Provider Tasks",
  TASKS: "Tasks",
  INVENTORY_LIST: "Inventory List",
  CONTACT_DIRECTORY: "Contact Directory",
  CLEAR_ALL: "Clear All",
  APPLY: "Apply",
  CLOSE: "Close",

  // Add more text as needed
};

export const STATUS_FOR_TASK = [
  { label: "Pending", value: "pending" },
  { label: "In Progress", value: "inProgress" },
  { label: "Completed", value: "completed" },
  { label: "In Review", value: "InReview" },
];

export const CSV_HEADERS_PATIENT_REPORTS = [
  { label: "BSA Id", key: "bsaId" },
  { label: "Patient Id", key: "patientId" },
  { label: "Patient Name", key: "patientName" },
  { label: "Gender", key: "gender" },
  { label: "Visit Type", key: "visitType" },
  { label: "Base Camp", key: "baseCamp" },
  { label: "Status", key: "status" },
  { label: "Contact Number", key: "contactNumber" },
  { label: "Emergency Contact", key: "emergencyContact" },
  // { label: "Diagnoses", key: "diagnoses" },
  // { label: "Orders", key: "orders" },
  // { label: "Medications", key: "medications" },
];

export const CSV_HEADERS_VISIT_REPORTS = [
  { label: "Id", key: "id" },
  { label: "Patient Name", key: "patientName" },
  { label: "BSA Id", key: "bsaId" },
  { label: "Visit Date", key: "date" },
  { label: "Visit Type", key: "type" },
  { label: "Facility", key: "facility" },
  { label: "Chief Complaints", key: "chiefComplaint" },
  { label: "Type Of Care", key: "care" },
  { label: "Status", key: "status" },
  { label: "Signed/Unsigned", key: "visitSigned" },
];

export const STATUS_FOR_VISIT_REPORT = [
  { label: "Discharged", value: "discharged" },
  { label: "Visit Created", value: "Visit Created" },
  { label: "Draft", value: "Draft" },
  { label: "Expected", value: "transferToJHC" },
  { label: "Transfer Off Property", value: "transferOffProperty" },
  { label: "In Disposition", value: "InDisposition" },
  { label: "Observation", value: "transferToClinic" },
  { label: "Reported", value: "Reported" },
];

export const STATUS_FOR_UNSIGNED_SIGN_VISIT_REPORT = [
  { label: "Signed", value: "true" },
  { label: "Unsigned", value: "false" },
];

export const STATUS_FOR_TYPE_OF_VISIT_VISIT_REPORT = [
  { label: "EMS", value: "Scene" },
  { label: "Walk In", value: "WALK_In_Visit" },
];

export const STATUS_FOR_GENDER_PATIENT_REPORT = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
];
